.panel { flex: 1; display: flex; flex-direction: column; overflow: hidden; }

/* ── Шапка ── */
.header {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 12px 20px;
  flex-shrink: 0;
  padding: 24px 28px 16px;
}


.heading { flex: 1; min-width: 220px; }

.back {
  margin: 0 0 6px -2px;
  padding: 2px;
  font-size: 13.5px;
  color: var(--blue);
  background: none;
  border: none;
  cursor: pointer;
}

:global(html.dark) .back { color: var(--navy-accent); }

.title {
  margin: 0;
  font-size: 26px;
  font-weight: 650;
  line-height: 1.2;
  letter-spacing: -.01em;
  color: var(--text);
}

.summary { margin: 4px 0 0; font-size: 14px; color: var(--text2); }

.actions { display: flex; flex-wrap: wrap; align-items: center; gap: 8px; }

.segment {
  display: inline-flex;
  height: 36px;
  padding: 3px;
  background: var(--table-even);
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
}

.segButton {
  padding: 0 12px;
  font-size: 13px;
  font-weight: 500;
  color: var(--text2);
  background: none;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.segActive { color: var(--text); background: var(--card-bg); box-shadow: 0 1px 2px var(--shadow); }

.errorBar {
  margin: 0 28px 12px;
  padding: 10px 14px;
  font-size: 13.5px;
  color: var(--err);
  background: var(--err-bg);
  border-radius: var(--r-sm);
}

/* ── Содержимое ── */
.body { flex: 1; overflow-y: auto; padding: 0 28px 28px; }

/* Сводка слева, схема справа. На узком экране складываются в столбец —
   правило ниже по файлу, чтобы оно побеждало в каскаде. */
.layout { display: flex; gap: 24px; align-items: flex-start; flex-wrap: wrap; }
.layoutLeft { flex: 0 0 260px; min-width: 220px; }
.layoutRight { flex: 1; min-width: 300px; max-width: 760px; }

.cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 12px;
}

.card {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 16px;
  text-align: left;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
  cursor: pointer;
  transition: border-color .15s;
}

.card:hover { border-color: var(--blue); }

.cardIcon {
  display: grid;
  place-items: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  color: var(--blue);
  background: var(--blue-lt);
  border-radius: var(--r-sm);
}

:global(html.dark) .cardIcon { color: var(--navy-accent); }

.cardText { display: flex; flex-direction: column; gap: 3px; min-width: 0; }
.cardName { font-size: 15px; font-weight: 600; color: var(--text); }
.cardMeta { font-size: 13px; line-height: 1.45; color: var(--text2); }

.warning {
  margin-bottom: 16px;
  padding: 12px 14px;
  font-size: 13.5px;
  color: var(--text);
  background: var(--warn-bg);
  border: 1px solid color-mix(in srgb, var(--warn) 35%, transparent);
  border-radius: var(--r-sm);
}

.warningTitle { margin-bottom: 8px; font-weight: 600; }

.swList { display: flex; flex-wrap: wrap; gap: 4px; }

.swTag {
  padding: 1px 7px;
  font-family: var(--mono);
  font-size: 12px;
  line-height: 18px;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: 4px;
}

.error,
.success {
  margin-bottom: 16px;
  padding: 10px 14px;
  font-size: 13.5px;
  border-radius: var(--r-sm);
}

.error { color: var(--err); background: var(--err-bg); }
.success { color: var(--ok); background: var(--ok-bg); }

.empty {
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 24px;
  text-align: center;
}

.emptyBox {
  max-width: 560px;
  padding: 28px;
  background: var(--card-bg);
  border: 1px dashed var(--border);
  border-radius: var(--r-lg);
}

.emptyTitle { font-size: 17px; font-weight: 600; color: var(--text); }

.emptyText {
  max-width: 46ch;
  margin: 8px 0 0;
  font-size: 14px;
  line-height: 1.5;
  color: var(--text2);
}

/* ── Табличный вид шкафа ── */
.tableWrap {
  overflow-x: auto;
  background: var(--card-bg);
  border: 1px solid var(--border);
  border-radius: var(--r-md);
}

.table { width: 100%; font-size: 13.5px; border-collapse: collapse; }

.table th {
  padding: 10px 12px;
  font-size: 12.5px;
  font-weight: 600;
  color: var(--text2);
  text-align: left;
  box-shadow: inset 0 -1px 0 var(--border);
}

.table td {
  padding: 10px 12px;
  color: var(--text);
  vertical-align: middle;
  border-bottom: 1px solid var(--border);
}

.table tbody tr:last-child td { border-bottom: none; }

.unit { width: 64px; font-family: var(--mono); font-size: 12.5px; color: var(--text2); }
.muted { color: var(--text2); }
.right { text-align: right; }
.mismatch { margin-top: 3px; font-size: 12.5px; color: var(--err); }

@media (max-width: 699px) {
  .header { padding: 16px 16px 12px; align-items: flex-start; }
  .title { font-size: 22px; }
  .errorBar { margin: 0 16px 12px; }
  .body { padding: 0 16px 16px; }
  .layout { flex-direction: column; gap: 16px; }
  .layoutLeft, .layoutRight { flex: none; width: 100%; min-width: 0; }
  .cards { grid-template-columns: 1fr; }
}
